import {useEffect, useState} from "react";
import * as React from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import {useLocation, useNavigate} from "react-router-dom";
import {useSnackbar} from "notistack";
import { z } from "zod";
import {FindStatusColorByIdReactQuery, SaveStatusColorReactQuery} from "./StatusColorReactQuery";
import {StatusColorProps, StatusOverLeapProps} from "../../../Shared/Types/StatusColorProps";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import {
    Container, FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputLabel, OutlinedInput,
    Select, Stack, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
    TextField, useTheme
} from "@mui/material";
import Box from "@mui/material/Box";
import {ACard} from "@atiautomacao/ati-ui-library";
import MenuItem from "@mui/material/MenuItem";
import {HeaderMenu} from "../HeaderMenu";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {Skid} from "../../../Shared/Types/PowerStation";
import {sortSkid} from "../PowerStation/PowerStationFormPage";
import {FindAllAlarmSeverityReactQuery} from "../AlarmSeverity/AlarmSeverityReactQuery";
import {AlarmSeverity} from "../NotificationGroup/NotificationGroupFormPage";







export const StatusColorHomePageForm = () => {

    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const id = location.state?.id as string;
    const navigate = useNavigate();
    const stringSchema = z.string();

    const theme = useTheme();
    const headerBackGroundColor = theme.palette.mode === 'light' ? 'rgba(4,104,190,0.92)' : theme.palette.background.default
    const [inputValue, setInputValue] = useState('');


    const [name, setName] = useState<string>("");
    const [color, setColor] = useState<string>("");
    const [statusTypeEnum, setStatusTypeEnum] = useState<string>("");
    const [priority, setPriority] = useState<number | "">("");
    const [priorityOfStatusOverLeap, setPriorityOfStatusOverLeap] = useState<number | "">("");
    const [statusOverLeapList, setStatusOverLeapList] = useState<StatusOverLeapProps[]>([]);



    const statusColorSchema = z.object({
        id: z.number().nullable(),
        name: z.string().min(1, "O nome é obrigatório").max(40, "O nome deve ter no máximo 40 caracteres"),
        color: z.string().min(1, "A cor é obrigatória").regex(/^[0-9A-Fa-f]{6}$/, "A cor deve ser um hexadecimal válido"),
        statusTypeEnum: z.string().min(1, "O tipo de status é obrigatório"),
        priority: z.number().min(1, "A prioridade é obrigatória"),
    });


    const mutationSave = SaveStatusColorReactQuery();
    const mutationFindById = FindStatusColorByIdReactQuery();
    const {data: alarmsSeverity} = FindAllAlarmSeverityReactQuery();
    const [checkedAlarmsSeverity, setCheckedAlarmsSeverity] = useState<AlarmSeverity[]>([]);



    useEffect(() => {
        if (alarmsSeverity?.data && Array.isArray(alarmsSeverity.data)) {
            const initializedAlarmsSeverity = alarmsSeverity?.data.map((alarmSeverity: AlarmSeverity) => ({
                id: alarmSeverity.id,
                name: alarmSeverity.name,
                color: alarmSeverity.color,
                selected: false,
            }));
            setCheckedAlarmsSeverity(initializedAlarmsSeverity);
        } else {
            setCheckedAlarmsSeverity([]);
        }
    }, [alarmsSeverity]);

    const handleChangeAlarmsSeverityCheckbox = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        let updatedAlarmSeverity = checkedAlarmsSeverity.map((alarmSeverity, i) => ({
            ...alarmSeverity,
            selected: i === index ? event.target.checked : false // Desmarcar todos os outros
        }));

        setCheckedAlarmsSeverity(updatedAlarmSeverity);
    };



    useEffect(() => {
        if (id) {
            mutationFindById.mutate(Number(id), {
                onSuccess: (data) => {
                    const statusColor = data?.data as StatusColorProps;
                    setName(statusColor.name);
                    setColor(statusColor.color.trim());
                    setStatusTypeEnum(statusColor.statusTypeEnum);
                    setPriority(statusColor.priority);
                    // Aqui adicionamos a lista de StatusOverLeap
                    setStatusOverLeapList(statusColor.statusOverLeapList ?? []);
                },
            });
        }
    }, []);





    const handleSave = () => {
        if (priority === "" || priority > 6 || priority < 0) {
            enqueueSnackbar("A prioridade deve ser um número entre 1 e 6.", { variant: "error" });
            return;
        }
        const newStatusColor = {
            id: id != null ? Number(id) : null,
            name: name.trim(),
            color: color.replace(/#/g, "").trim(),
            statusTypeEnum: statusTypeEnum.trim(),
            priority: Number(priority),
            statusOverLeapList: statusOverLeapList.map(item => ({
                id: item.id ?? null,
                alarmSeverity: {
                    id: item.alarmSeverity.id,
                },
                priority: Number(item.priority)
            }))
        };

        console.log("newStatusColor", newStatusColor);

        mutationSave.mutate(newStatusColor, {
            onSuccess: () => {
                navigate(SystemRoutes.SETTINGS_STATUS_COLOR);
            }
        });


    }

    const handleAddItem = () => {
        const selectedAlarmSeverity = checkedAlarmsSeverity.find(item => item.selected);

        if(!selectedAlarmSeverity){
            enqueueSnackbar("Selecione uma severidade de alarme.", { variant: "error" });
            return;
        }

        const newItem: StatusOverLeapProps = {
            alarmSeverity: selectedAlarmSeverity,
            priority: Number(priorityOfStatusOverLeap)
        };

        setStatusOverLeapList(prevList => [...prevList, newItem]);

        // Limpa os campos após adicionar
        setCheckedAlarmsSeverity(prev =>
            prev.map(item => ({ ...item, selected: false }))
        );
        setPriorityOfStatusOverLeap("");

    };




    function handleOnDelete(index: any) {
        setStatusOverLeapList((prevList) => prevList.filter((_, i) => i !== index));
    }
    console.log("statusOverLeapList", statusOverLeapList);

    return (
        <>
            <HeaderMenu isOnSave={true} handleSave={handleSave} systemRoutes={SystemRoutes.SETTINGS_STATUS_COLOR}/>
            <Box>
                <ACard>
                    <Container style={{marginLeft: -10, display: 'flex', flexDirection: "column", alignItems: 'left', justifyContent: 'left', columnGap: 30}}>
                        <Box style={{marginBottom: 20}}>
                            <InputLabel>Nome</InputLabel>
                            <TextField
                                error={name === ""}
                                fullWidth
                                variant="standard"
                                placeholder="Nome"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            {name === "" && (
                                <FormHelperText style={{color: "#d70909"}}>Campo obrigatório.</FormHelperText>
                            )}
                        </Box>

                        <Box style={{marginBottom: 20}}>
                            <InputLabel>Cor</InputLabel>
                            <Box style={{display: "flex", flexDirection: 'row', justifyContent: "space-between", gap: 10}}>
                                <TextField
                                    error={color === ""}
                                    variant="standard"
                                    type="color"
                                    value={color.includes("#") ? `${color}` : `#${color}`}
                                    onChange={(e) => setColor(e.target.value)}
                                    style={{width: 24}}
                                />
                                <TextField
                                    error={color === ""}
                                    variant="standard"
                                    placeholder="Código hexadecimal"
                                    onChange={(e) => setColor(e.target.value)}
                                    value={color.includes("#") ? `${color}` : `#${color}`}
                                    style={{flex: 1}}
                                />
                            </Box>
                            {color === "" && (
                                <FormHelperText style={{color: "#d70909"}}>Campo obrigatório.</FormHelperText>
                            )}
                        </Box>

                        <Box style={{marginBottom: 20}}>
                            <InputLabel>Tipo de Status</InputLabel>
                            <Select
                                error={statusTypeEnum === ""}
                                fullWidth
                                value={statusTypeEnum}
                                onChange={(e) => setStatusTypeEnum(e.target.value)}
                            >
                                <MenuItem value="POWER_STATION">POWER_STATION</MenuItem>
                                <MenuItem value="SKID">SKID</MenuItem>
                                <MenuItem value="EQUIPMENT">EQUIPMENT</MenuItem>
                            </Select>
                            {statusTypeEnum === "" && (
                                <FormHelperText style={{color: "#d70909"}}>Campo obrigatório.</FormHelperText>
                            )}
                        </Box>

                        <Box style={{marginBottom: 20}}>
                            <InputLabel>Prioridade</InputLabel>
                            <TextField
                                error={priority === ""}
                                fullWidth
                                variant="standard"
                                type="number"
                                placeholder="Prioridade"
                                value={priority}
                                onChange={(e) => setPriority(Number(e.target.value))}
                            />
                            {priority === "" && (
                                <FormHelperText style={{color: "#d70909"}}>Campo obrigatório.</FormHelperText>
                            )}
                        </Box>
                        <Grid container spacing={1} alignItems="center" sx={{ pb: 2, maxWidth: '600px' }}>
                            <Grid item xs={12} sx={{ display: 'flex' }}>
                                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', maxWidth: '800px' }}>
                                    <FormControl sx={{ width: '320px'}}>
                                        <InputLabel id="select-alarmSeverity-label">Selecionar Severidade de Alarme</InputLabel>
                                        <Select
                                            labelId="select-alarmSeverity-label"
                                            id="select-alarmSeverity"
                                            input={<OutlinedInput label="Selecionar Severidade de Alarme" />}
                                            value={checkedAlarmsSeverity.find(item => item.selected)?.id ?? ""}
                                            onChange={(e) => {
                                                const selectedId = e.target.value;
                                                setCheckedAlarmsSeverity(prev =>
                                                    prev.map(item => ({
                                                        ...item,
                                                        selected: item.id === selectedId, // Marca o item selecionado
                                                    }))
                                                );
                                            }}
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    height: '40px',
                                                    '& input': {
                                                        padding: '8px 14px',
                                                    },
                                                },
                                            }}
                                        >
                                            {checkedAlarmsSeverity.map((alarmSeverity) => (
                                                <MenuItem key={alarmSeverity.id} value={alarmSeverity.id}>
                                                    {alarmSeverity.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {/* Input de Prioridade */}
                                    <TextField
                                        type="number"
                                        label="Prioridade de Al. de Sobreposição"
                                        value={priorityOfStatusOverLeap ?? ""}
                                        onChange={(e) => setPriorityOfStatusOverLeap(Number(e.target.value))}
                                        variant="standard"
                                        sx={{
                                            flex: 5,
                                            width: '200px',
                                            '& .MuiOutlinedInput-root': {
                                                height: '40px',
                                                '& input': {
                                                    padding: '8px 14px',
                                                },
                                            },
                                        }}
                                    />
                                    <IconButton
                                        color={theme.palette.mode === 'light' ? "primary" : "inherit"}
                                        onClick={handleAddItem}
                                        sx={{ ml: 1, alignSelf: 'center' }} // Alinha o botão verticalmente com o campo de texto
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </Box>

                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ maxWidth: '800px' }}>
                            <Grid item xs={12}>
                                <TableContainer sx={{ width: '69%' }}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    sx={{ minWidth: 10, backgroundColor: headerBackGroundColor, color: 'white', fontSize: '0.875rem', padding: '8px 16px' }}
                                                >
                                                    <Stack spacing={0} sx={{ m: 0, p: 0 }}>
                                                        <Box>
                                                            {'Prioridade'}
                                                        </Box>
                                                    </Stack>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    sx={{ minWidth: 10, backgroundColor: headerBackGroundColor, color: 'white', fontSize: '0.875rem', padding: '8px 16px' }}
                                                >
                                                    <Stack spacing={0} sx={{ m: 0, p: 0 }}>
                                                        <Box>
                                                            {'Nome'}
                                                        </Box>
                                                    </Stack>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    sx={{ minWidth: 10, backgroundColor: headerBackGroundColor, color: 'white', fontSize: '0.875rem', padding: '2px 6px' }}
                                                >
                                                    <Stack spacing={0} sx={{ m: 0, p: 0 }}>
                                                        <Box>
                                                            {'Ações'}
                                                        </Box>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Array.isArray(statusOverLeapList) && statusOverLeapList.length > 0 ? statusOverLeapList.map((column, index) => (
                                                <TableRow key={index.valueOf()}>
                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            fontSize: '0.875rem',
                                                            padding: '8px 16px',
                                                            height: '40px',
                                                            verticalAlign: 'middle',
                                                        }}
                                                    >
                                                        {column?.priority}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            fontSize: '0.875rem',
                                                            padding: '8px 16px',
                                                            height: '40px',
                                                            verticalAlign: 'middle',
                                                        }}
                                                    >
                                                        {column?.alarmSeverity?.name}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            fontSize: '0.875rem',
                                                            padding: '2px 6px',
                                                            height: '40px',
                                                            verticalAlign: 'middle',
                                                        }}
                                                    >
                                                        <IconButton edge="end" aria-label="delete" onClick={() => { handleOnDelete(index); }}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )) : null}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </Container>
                </ACard>
            </Box>
        </>
    );
}

export function StatusColorFormPage() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <StatusColorHomePageForm />
        </QueryClientProvider>
    )
}